import { http } from '@/utils/http';
import qs from 'qs';

const urlPrefix = 'vote/2020project/2020dreamsong/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};

interface ISubmit {
  title: string;
  phone: string;
  chinaid: string;
}
const submit = (data: ISubmit) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};

export { getBaseInfo, getRules, submit };
